import axios from 'axios'
const api=axios.create({
    // baseURL:'http://localhost:8000',
    baseURL:'https://vantourserver.cubeaddis.com',
    withCredentials:true,
    headers:{
        'Content-Type':'multipart/form-data'
    }
});
api.interceptors.request.use(
    (config)=>{
        const accessToken=JSON.parse(localStorage.getItem("Token"));
        if(accessToken){
            config.headers['Authorization']=`Bearer ${accessToken}`;
        }
        return config;

    },(error)=>{
        return Promise.reject(error)
    }
)
export default api;
